import { Link } from 'react-router-dom';
import { Status } from 'library/components/shop';
import DeliveryCompany from './frames/DeliveryCompany';
import OrderNumber from './frames/OrderNumber/index';
import OrderPrice from './frames/OrderPrice';
import ProductTitle from './frames/ProductTitle';
import { useModuleByCodeParam } from '../../../../shared/hooks/use-module-by-code-param.ts';
import styles from './OrderCard.module.scss';

const OrderCard = ({ order }) => {
  const { code, permissions } = useModuleByCodeParam();

  const calcultePartnerPrice = () => {
    let partner = 0;
    for (const item of order.items) {
      if (item.partner_price) {
        partner += item.partner_price.partner_amount * item.count;
      } else {
        partner += item.product.current_price * item.count;
      }
    }

    return partner;
  };

  return (
    <Link
      to={{ pathname: `/shop/${code}/orders/order/${order.id}`, state: { order } }}
      className={styles.order}
    >
      <div className={styles.order__container}>
        {/* <div className={styles.photo}>
						<OrderPhoto photos={order.items.map((item) => item.product.promo_image)} />
				</div> */}
        <div className={styles.number}>
          <OrderNumber orderNumber={order.short_id} date={order.updated_at} />
        </div>
        <div className={styles.status}>
          <Status order={order} />
        </div>
        <div className={styles.title}>
          <ProductTitle products={order.items} />
        </div>
        <div className={styles.price}>
          <OrderPrice price={permissions.can_sell ? calcultePartnerPrice() : order.amount} />
        </div>
        <div className={styles.delivery}>
          <DeliveryCompany order={order} />
        </div>
      </div>
    </Link>
  );
};

export default OrderCard;
